'use client';

import React, { memo } from 'react';


interface AppLogoProps {
  size?: number;
  className?: string;
  onClick?: () => void;
  variant?: 'light' | 'dark'; // light = for dark backgrounds, dark = for light backgrounds
  showWordmark?: boolean;
}

const AppLogo = memo(function AppLogo({
  size = 40,
  className = '',
  onClick,
  variant = 'dark',
  showWordmark = false,
}: AppLogoProps) {
  const isDark = variant === 'dark';
  const bgColor = isDark ? '#0B1628' : '#FFFFFF';
  const textColor = isDark ? '#F9F7F4' : '#0B1628';
  const goldColor = '#C9A96E';

  const mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Java Apartments monogram"
      className="flex-shrink-0"
    >
      {/* Background square */}
      <rect width="48" height="48" fill={bgColor} />
      {/* Gold bottom accent line */}
      <rect x="8" y="40" width="32" height="1.5" fill={goldColor} />
      {/* J letterform */}
      <text
        x="10"
        y="33"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="26"
        fontWeight="400"
        fill={textColor}
        letterSpacing="-1"
      >J</text>
      {/* A letterform */}
      <text
        x="24"
        y="33"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="26"
        fontWeight="400"
        fill={goldColor}
        letterSpacing="-1"
      >A</text>
    </svg>
  );

  const container = (
    <div
      className={`inline-flex items-center gap-3 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      {mark}
      {showWordmark && (
        <div className="flex flex-col">
          <span
            style={{
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontSize: '0.95rem',
              fontWeight: 400,
              letterSpacing: '0.18em',
              color: isDark ? '#0B1628' : '#F9F7F4',
              lineHeight: 1,
              textTransform: 'uppercase',
            }}
          >
            JAVA
          </span>
          <span
            style={{
              fontSize: '0.55rem',
              fontWeight: 600,
              letterSpacing: '0.22em',
              color: '#C9A96E',
              lineHeight: 1,
              marginTop: '3px',
              textTransform: 'uppercase',
            }}
          >
            APARTMENTS
          </span>
        </div>
      )}
    </div>
  );

  return container;
});

export default AppLogo;
